export default __webpack_public_path__ + "static/triggered-spotlight-light-98b72592a2a7af89ef62ce0ab8407436.png";